exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1v9J1ZEXqi{text-align:center;color:#fff;background-color:#4b5765}._3rNblTA0_Z{display:block;padding:30px 0 40px;text-decoration:none;color:inherit}._3rNblTA0_Z+._3rNblTA0_Z{border-top:1px solid #6f7984}._1QBdJ1cCGe{font-size:10px;text-transform:uppercase;letter-spacing:1px;color:#d8dde4}._2lLA5oWQ7u{font-size:18px;font-weight:700;margin:6px 0}._3bzwuVAjzT{font-weight:700;color:#00f4f6}._19DZbK4cwe{margin-right:5px}._3nJlWp0BAe{padding:50px 0}", ""]);

// exports
exports.locals = {
	"main": "_1v9J1ZEXqi",
	"item": "_3rNblTA0_Z",
	"category": "_1QBdJ1cCGe",
	"name": "_2lLA5oWQ7u",
	"comments": "_3bzwuVAjzT",
	"commentsIcon": "_19DZbK4cwe",
	"loader": "_3nJlWp0BAe"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize&modules&importLoaders=1&localIdentName=[hash:base64:10]!./~/postcss-loader!./~/sass-loader?includePaths[]=%2Fvar%2Fwww%2Fyii%2Fprod.smartprogress%2Fsrc%2Fsass!./src/react/elements/GoalsPage/MostDiscussed.scss
// module id = 693
// module chunks = 5